// en-US
import translations_EN from './locales/en.json'
import icon_EN from '../images/flags/usa.svg'
// ru-RU
import translations_RU from './locales/ru.json'
import icon_RU from '../images/flags/russia.svg'
// PL
import icon_PL from '../images/flags/poland.svg'
// FR
import icon_FR from '../images/flags/france.svg'
// IT
import icon_IT from '../images/flags/italy.svg'
// CH
import icon_CH from '../images/flags/china.svg'

export default [
    {
        value: 'en-US',
        code: 'en',
        label: 'English',
        translations: translations_EN,
        icon: icon_EN,
        is_enabled: true,
        is_silent: false,
        is_visible: true,
    },
    {
        value: 'pl-PL',
        code: 'pl',
        label: 'Polski',
        translations: null,
        icon: icon_PL,
        is_enabled: false,
        is_silent: false,
        is_visible: true,
    },
    {
        value: 'fr-FR',
        code: 'fr',
        label: 'Français',
        translations: null,
        icon: icon_FR,
        is_enabled: false,
        is_silent: false,
        is_visible: true,
    },
    {
        value: 'it-IT',
        code: 'it',
        label: 'Italiano',
        translations: null,
        icon: icon_IT,
        is_enabled: false,
        is_silent: false,
        is_visible: true,
    },
    {
        value: 'ru-RU',
        code: 'ru',
        label: 'Русский',
        translations: translations_RU,
        icon: icon_RU,
        is_enabled: true,
        is_silent: true,
        is_visible: true,
    },
    {
        value: 'ch-ZH',
        code: 'zh',
        label: '中国',
        translations: null,
        icon: icon_CH,
        is_enabled: false,
        is_silent: false,
        is_visible: true,
    },
]
